import BezierEasing from 'bezier-easing';
import AnimationController from '../controllers/animation';

// duration: milliseconds

export default function (bezier, from, to, duration, callback, completeCallback = null) {
	const controllers = {};
	const easingEquation = BezierEasing(...bezier);
	const startTime = Date.now();
	let timeElapsed = 0;

	const getValue = () => {
		const progressRatio = Math.min(1, timeElapsed / duration);
		const value = from + easingEquation(progressRatio) * (to - from);
		return value;
	};

	const loop = () => {
		timeElapsed = Date.now() - startTime;
		if (timeElapsed < duration) {
			callback(getValue());
		} else {
			callback(getValue());
			if (typeof (completeCallback) === 'function') {
				completeCallback(getValue());
			}
			AnimationController.clear(controllers.animation);
		}
	};

	controllers.animation = AnimationController.set({
		update: () => true,
		render: loop
	});
}
